import { render, staticRenderFns } from "./TradeRequestDirectList.vue?vue&type=template&id=43a63b66"
import script from "./TradeRequestDirectList.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports